import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/cases";
import Links from "components/pages/admin/cases/list/links";
import Loading from "components/pages/loading";
import Row from "./row";

export default function AdminCasesList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (id) => {
    setRecords(records.filter((record) => record.id !== id));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.cases));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="max-w-screen-lg mx-auto">
      <h1 className="text-center">Cases</h1>
      <div className="flex justify-between mb-1">
        <Links />
        <a className="btn btn-outline-black btn-sm" href="/admin/cases/new">New Case</a>
      </div>
      <div className="table-responsive">
        <table className="table text-center">
          <thead>
            <tr>
              <th>Active</th>
              <th>Name</th>
              <th>Number</th>
              <th>Tags</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <Row key={record.id} onDestroy={onDestroy} record={record} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
